export enum PublicReduxAction {
  PUBLIC_AUTH_SET_LOGIN_STATUS = 'PUBLIC_AUTH_SET_LOGIN_STATUS',
  PUBLIC_LOGOUT = 'PUBLIC_LOGOUT',
}

const setLoginStatus = (payload: any): any => ({
  type: PublicReduxAction.PUBLIC_AUTH_SET_LOGIN_STATUS,
  payload,
});

const doLogout = (payload: any): any => ({
  type: PublicReduxAction.PUBLIC_LOGOUT,
  payload,
});

export const PublicActions = {
  setLoginStatus,
  doLogout,
};
